import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './ResetPasswordComponent.css'
import { withStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Paper from '@material-ui/core/Paper'
import Divider from '@material-ui/core/Divider'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import { withRouter } from 'react-router'
import { validateEmail } from 'redux/helpers/authHelpers'
const styles = theme => ({
  buttonSignin: {
    lineHeight: '50px'
  },
  rootPaper: {
    padding: theme.spacing.unit * 2
  },
  label: {},
  buttonContainerSignin: {
    color: theme.palette.secondary.main,
    height: '50px',
    width: '100%'
  },
  buttonContainerSignup: {
    color: theme.palette.secondary.main,
    merginTop: '10px',
    height: '40px',
    width: '100%'
  },
  buttonSignup: {
    lineHeight: '40px'
  }
})
class ResetPasswordComponent extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    resetPassword: PropTypes.func.isRequired,
    clearReset: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired
  }
  state = {
    email: '',
    emailError: null,
    errorMessage: void 0
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.auth && nextProps.auth.errorMessage !== void 0) {
      this.setState({ emailError: nextProps.auth.errorMessage })
    }
  }
  handleEmailChange = e => {
    this.setState({
      email: e.target.value,
      emailError: null,
      errorMessage: void 0
    })
  }
  onKeyPressed = e => {
    if (e.charCode === 13) {
      // enter key pressed
      e.preventDefault()
      this.handleSigninClick()
    }
  }
  handleBackClick = () => {
    this.props.clearReset()
    this.props.history.replace('/signin')
  }
  handleSigninClick = () => {
    if (!validateEmail(this.state.email)) {
      this.setState({ emailError: 'Email invalide' })
      return
    }
    this.props.resetPassword(this.state.email)
  }

  render() {
    const { classes, auth } = this.props
    return (
      <Grid
        className="loginPage"
        container
        alignItems="center"
        justify="center"
        spacing={0}>
        <Paper className={classes.rootPaper} elevation={5}>
          <Grid container direction="row" alignItems="center" justify="center">
            <Grid item xs={11}>
              <Typography
                variant="title"
                style={{ padding: 10 }}
                color="default"
                gutterBottom
                align="center">
                Réinitialiser votre mot de passe
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <TextField
                autoFocus
                fullWidth
                label="Email"
                type="email"
                disabled={!!auth.resetSuccess}
                value={this.state.email}
                onChange={this.handleEmailChange}
                error={!!this.state.emailError}
                helperText={this.state.emailError}
              />
            </Grid>
            <Grid item xs={10} container alignItems="center" justify="center">
              <Grid item>
                <Button
                  disabled={auth.resetSuccess || this.state.email === ''}
                  onClick={this.handleSigninClick}
                  variant="raised"
                  color="primary">
                  Envoyer l'email de réinitialisation
                </Button>
              </Grid>
              <Grid item>
                <Divider style={{ marginTop: '10px', marginBottom: '10px' }} />
              </Grid>
            </Grid>
            {auth.resetSuccess && (
              <Grid item>
                <Typography variant="subheading" color="primary">
                  L'email de réinitialisation a bien été envoyé
                </Typography>
              </Grid>
            )}
            <Grid item xs={11} container alignItems="center" justify="center">
              <Button onClick={this.handleBackClick} color="secondary">
                Retour
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    )
  }
}
export default withRouter(withStyles(styles)(ResetPasswordComponent))



// WEBPACK FOOTER //
// ./src/routes/ResetPassword/components/ResetPasswordComponent.js